import {AfterViewInit, Component, ElementRef, HostListener, inject, OnDestroy, OnInit, signal, ViewChild, WritableSignal} from '@angular/core';
import {FormControl, FormGroup, UntypedFormControl} from '@angular/forms';
import {MatSelectChange} from '@angular/material/select';
import {TranslateService} from '@ngx-translate/core';
import {GridComponent} from '@syncfusion/ej2-angular-grids';
import {TreeViewComponent} from '@syncfusion/ej2-angular-navigations';
import {LocalStorageService} from 'src/app/local-storage.service';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {SwissAppConfigModels} from 'src/app/models/swissappconfig-models';
import {TimeSheetModels} from 'src/app/models/timesheet-models';
import {MainDataService} from 'src/app/services/main-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {TimeSheetService} from 'src/app/services/time-sheet.service';
import {faDatabase} from '@fortawesome/free-solid-svg-icons';
import {Router} from '@angular/router';
import {BackupService, ServerBackupInfo} from 'src/app/services/backup.service';
import {AppEinstellungenBaseComponent} from './app-einstellung-base-component';
import {SpeedDialItemEventArgs} from '@syncfusion/ej2-angular-buttons';
import {UserAuthenticationService} from '../../services/user-authentication.service';
import {HelperService} from '../../services/helper.service';
import {Device, DeviceDetectionService} from '../../services/device-detection-service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DocumentManagementService} from '../../services/document-management.service';
import {BehaviorSubject, tap} from 'rxjs';
import {VinavonUpdateService} from '../../services/vinavon-update.service';
import {SwissInternModels} from '../../models/swissintern-models';
import Anwender = BenutzerModels.Anwender;
import EmptyAnwender = BenutzerModels.EmptyAnwender;
import SwissAppUserConfig = SwissAppConfigModels.SwissAppUserConfig;
import DEFAULT_SYNC_PERIOD = ServiceAppModels.DEFAULT_SYNC_PERIOD;
import SynchronizationPeriod = ServiceAppModels.SynchronizationPeriod;
import DEFAULT_OBJECT_SEARCH_SETTINGS = SwissInternModels.DEFAULT_OBJECT_SEARCH_SETTINGS;
import TreeViewDisplaySettings = SwissInternModels.TreeViewDisplaySettings;
import {SWISS_SERVICE_APP_DB_STORE_NAME} from "../../models/local-storage-names";

@Component({
    selector: 'app-app-einstellungen', templateUrl: './app-einstellungen.component.html', styleUrls: ['./app-einstellungen.component.scss'],
})
export class AppEinstellungenComponent extends AppEinstellungenBaseComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('treevalidate') treeSA?: TreeViewComponent;
    @ViewChild('treeoff') treeOffline?: TreeViewComponent;
    @ViewChild('gridRechte') public gridRechte?: GridComponent;
    @ViewChild('vinbkupUpload') public vinbkupUpload?: ElementRef<HTMLElement>;
    @ViewChild('vinbkInput') public vinbkInput?: any;
    @ViewChild('vinbkApply') public vinbkApply?: any;
    @ViewChild('OrderFilterValue') public orderFilterValue?: ElementRef<HTMLInputElement>;

    faDatabase = faDatabase;
    vinbkup: any;
    backUpFileName = '';

    public offlineDaten: Object[] = [{
        id: 1, name: 'Mitarbeiter', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 2, name: 'Mitarbeitergruppen', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 3, name: 'Mandanten', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 4, name: 'Termine / Pendenzen', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 5, name: 'Dynamische Feldkonfigurationen', hasChild: false, expanded: false, isChecked: true,
    }, {
        id: 6, name: 'Adresstypen', hasChild: false, expanded: false, isChecked: true,
    },];

    public serviceAppDaten: Object[] = [{
        id: 1, name: 'Stammdaten', hasChild: true, expanded: false, isChecked: true,
    }, {id: 2, pid: 1, name: 'Mandanteninformationen / Adresse'}, {id: 3, pid: 1, name: 'Adresstypen'}, {id: 4, pid: 1, name: 'Benutzerrechte'}, {id: 5, pid: 1, name: 'Kostenstellen / Kostenstellenansätze'}, {
        id: 6, pid: 1, name: 'Spesen'
    }, {id: 7, pid: 1, name: 'Mitarbeiter / Mitarbeiteransätze'}, {id: 8, name: 'Produkte', hasChild: false, isChecked: true}, {id: 9, name: 'Objekte', hasChild: true, isChecked: true}, {id: 10, pid: 9, name: 'Aufträge'}, {
        id: 13, pid: 9, name: 'Adressen'
    }, {id: 14, pid: 9, name: 'Dokumente'}, {id: 15, pid: 9, name: 'Servicepositionen'}, {id: 16, name: 'Checkliste', hasChild: false, isChecked: true}, {id: 17, name: 'Dokumente', hasChild: false, isChecked: true},];

    public importProgress: BehaviorSubject<number> = new BehaviorSubject(0);
    public hideLoading: BehaviorSubject<boolean> = new BehaviorSubject(true);
    public webUserConfig: BenutzerModels.WebUserConfig;

    // TODO 2025-12-08 https://swissjira.atlassian.net/browse/EN-4208 migrate configs into Anwender for consistency (also why is userappconfig basically just Service App Config?)
    public sa_Config?: ServiceAppModels.SA_Config;
    public sa_DefaultMatExpense?: ServiceAppModels.SA_Expenses;
    public sa_DefaultMatCostCenter?: TimeSheetModels.CostCenter;
    public sa_DefaultObject?: ServiceAppModels.SA_DefaultObjekt;
    public sa_DefaultCostCenter?: TimeSheetModels.CostCenter;
    public sa_DefaultUserCostCenter?: TimeSheetModels.CostCenter;

    public currentUser: WritableSignal<Anwender> = signal(new EmptyAnwender());
    public currentUserConfig: WritableSignal<SwissAppUserConfig | undefined> = signal(undefined);
    public serverBackupInfo: WritableSignal<ServerBackupInfo | undefined> = signal(undefined);

    public languageForm = new UntypedFormControl('');
    /* Benutzerrechte */
    public dbBenutzerGruppen: BenutzerModels.BenutzerGruppe[] = [];
    public userHasGroups = false;
    public dataSourceBenutzerRechte: BenutzerModels.BenutzerRechtListElement[] = [];
    public sortOptions: object;

    public downloadedDocuments: BehaviorSubject<number> = new BehaviorSubject(0);
    public totalDocuments: BehaviorSubject<number> = new BehaviorSubject(0);

    public groupOptions?: { columns: string[] } = {columns: ['GroupOrder']};
    public menuItems: any[] = [];
    public treeViewSettingsForm = new FormGroup({
        width: new FormControl(),
        height: new FormControl<number>(0),
        activeTouchBubble: new FormControl<boolean>(true),
    });
    public serviceAppSettingsForm = new FormGroup({
        showTime: new FormControl<boolean>(false),
    });
    public showNav = false;
    public navBarShown: any;
    public syncPeriod = {} as ServiceAppModels.SynchronizationPeriod;
    public syncInPast?: number;
    public syncInFuture?: number;
    public notClosedOrder?: boolean;
    public device: Device;
    public pfdDialogObjects = false;
    public blockInput = false;
    public offlineObjects: any[] = [];
    treeViewSettings: TreeViewDisplaySettings = DEFAULT_OBJECT_SEARCH_SETTINGS;
    // #endregion
    protected showOrderFilter = false;
    protected nrOfDocs = new BehaviorSubject<number>(0);
    protected helperService = inject(HelperService);
    private swissAppReports: SwissAppConfigModels.SwissAppReport[] = [];
    private mandanten: SwissAppConfigModels.SwissAppMandant[] = [];
    private dbDokumente?: ServiceAppModels.SA_Document[];
    private kostenstellen: TimeSheetModels.CostCenter[] = [];
    private spesenarten: ServiceAppModels.SA_Expenses[] = [];
    private dbBenutzerRechte: BenutzerModels.BenutzerRecht[] = [];
    private key: any;
    private dbRechteGruppenReihenfolge: BenutzerModels.RechtGruppeReihenfolge[] = [];
    private documentManagementService = inject(DocumentManagementService);

    constructor(protected svcVinavonUpdate: VinavonUpdateService,
                private deviceDetectionService: DeviceDetectionService,
                private svcSA: ServiceAppService,
                private svcMessageBox: MessageBoxService,
                private svcMainData: MainDataService,
                public localStorageService: LocalStorageService,
                public svcSwissSettings: SwissSettingsService,
                private svcObjekte: ObjektDataService,
                private svcTimeSheet: TimeSheetService,
                private translate: TranslateService,
                public userAuthService: UserAuthenticationService,
                private router: Router,
                private backupService: BackupService) {
        super(localStorageService, userAuthService, svcSwissSettings);
        this.device = this.deviceDetectionService.getDevice();
        this.webUserConfig = this.svcSwissSettings.getWebConfig();
        this.userAuthService.getCurrentUser().pipe(
            takeUntilDestroyed(),
            tap((user) => {
                if (user) {
                    this.currentUser.set(user);
                } else {
                    this.currentUser.set(new EmptyAnwender());
                }
            })
        ).subscribe();
        this.svcSwissSettings.getSwissAppUserConfig$().pipe(
            takeUntilDestroyed(),
            tap((user) => {
                if (user) {
                    this.currentUserConfig.set(user);
                } else {
                    this.currentUserConfig.set(undefined);
                }
            })
        ).subscribe();
        this.sortOptions = {
            columns: [
                {field: 'OrderID', direction: 'Ascending'},
                {field: 'ID2', direction: 'Ascending'}
            ],
        };

        this.localStorageService.get('offlineObjekte', 'SwissWebMainDB', false, []).then((res) => {
            this.offlineObjects = res;
        });
        this.createNavBubble();
        this.showOrderFilter = (svcSwissSettings.getObjViewConfig() || 1) == 6;

        this.documentManagementService.getAllDocumentIDs().then(keys => {
            this.nrOfDocs.next(keys.length);
        });

        this.setStartPageOptions();
    }

    // #region Backup Functions
    get getPath(): string {
        return this.backUpFileName;
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent): void {
        this.key = event.key;
    }

    ngOnDestroy(): void {
        clearInterval(this.navBarShown);
    }

    ngOnInit(): void {
        this.displayValues();
        this.loadAppUserConfig().then(async () => {
            this.swissAppReports = await this.svcSwissSettings.getServiceAppReports();
        });
        this.loadAppGroupRightsOrder();
        this.loadAppUserGroups();
        this.loadAppUserRights();
        this.loadServiceAppConfig();
        this.loadServerBackupInfo();
        this.setLanguage();

        this.languageForm.valueChanges.subscribe({
            next: (res) => {
                this.translate.use(res);
                this.localStorageService.add('language', res, 'SwissTimeEntry', false, true);
            },
        });
    }

    public ngAfterViewInit(): void {
        this.svcSwissSettings.getServiceAppUserConfig().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(conf => {
            if (this.orderFilterValue?.nativeElement) {
                this.orderFilterValue.nativeElement.value = conf.orderFilterObjView6 || this.svcSwissSettings.getSwissAppConfig().orderFilterObjView6 || '';
            }
        });
    }

    public setLanguage(): void {
        this.localStorageService.get('language', 'SwissTimeEntry', true).then((res) => {
            if (this.webUserConfig.debugMode) {
                console.log(res);
            }
            if (!res) {
                this.languageForm.setValue(res);
            }
            this.languageForm.setValue(res);
        });
    }

    public groupTemplateFn(args: any): string {
        if (args != null && args.field === 'GroupOrder' && this.dbRechteGruppenReihenfolge) {
            return (args.headerText + ': ' + this.dbRechteGruppenReihenfolge.filter((rg) => rg.groupOrder === args.key)[0].rightsGrpText);
        } else {
            return args.headerText + ': ' + args.key;
        }
    }

    public loadAppGroupRightsOrder(): void {
        this.userAuthService.getRightsGroupsOrder().then((value) => {
            if (value) {
                this.dbRechteGruppenReihenfolge = value;
                if (this.webUserConfig.debugMode) {
                    console.log('dbRechteGruppenReihenfolge', this.dbRechteGruppenReihenfolge);
                }
            }
        });
    }

    public loadAppUserGroups(): void {
        this.userAuthService.getUserGroups().then((value) => {
            if (value) {
                this.dbBenutzerGruppen = value;
                if (this.dbBenutzerGruppen.length > 0) {
                    this.userHasGroups = true;
                }
                if (this.webUserConfig.debugMode) {
                    console.log('dbBenutzerGruppen', this.dbBenutzerGruppen);
                }
            }
        });
    }

    public loadAppUserRights(): void {
        this.groupOptions = {columns: ['GroupOrder']};
        this.userAuthService.getUserRights().then((value) => {
            if (value) {
                this.dbBenutzerRechte = value;
                this.dataSourceBenutzerRechte = [];

                if (this.webUserConfig.debugMode) {
                    console.log('dbBenutzerRechte', this.dbBenutzerRechte);
                }
                this.dbBenutzerRechte.forEach((br) => {
                    this.dataSourceBenutzerRechte.push({
                        ID: br.rightsID,
                        HatRecht: br.value,
                        HatGruppenRecht: br.groupValue,
                        HatEffektivRecht: br.effectiveValue,
                        Gruppe: br.rightsGrpText,
                        Rechtbeschreibung: br.rightsText,
                        Reihenfolge: br.textOrder,
                        OrderID: br.orderID,
                        GroupOrder: br.groupOrder,
                    });
                });
                if (this.webUserConfig.debugMode) {
                    console.log('dataSourceBenutzerRechte', this.dataSourceBenutzerRechte);
                }
                this.gridRechte!.refresh();
            }
        });
    }

    public async displayValues(): Promise<void> {
        this.syncPeriod = await this.localStorageService.get<SynchronizationPeriod>('service-app-mobile-config', 'SwissWebConfigDB', false, DEFAULT_SYNC_PERIOD);
        this.syncInPast = this.syncPeriod.syncInPast ? this.syncPeriod.syncInPast : ServiceAppModels.DEFAULT_SYNC_PERIOD.syncInPast;
        this.syncInFuture = this.syncPeriod.syncInFuture ? this.syncPeriod.syncInFuture : ServiceAppModels.DEFAULT_SYNC_PERIOD.syncInFuture;
        this.notClosedOrder = this.syncPeriod.notClosedOrder ? this.syncPeriod.notClosedOrder : ServiceAppModels.DEFAULT_SYNC_PERIOD.notClosedOrder;
        await this.localStorageService.add('service-app-mobile-config', this.syncPeriod, 'SwissWebConfigDB');

        this.pfdDialogObjects = await this.localStorageService.get('pfd_dialog_objects', 'SwissWebConfigDB', false, false);
        this.treeViewSettings = await this.localStorageService.get<TreeViewDisplaySettings>('treeviewSettings', 'SwissWebConfigDB', false, DEFAULT_OBJECT_SEARCH_SETTINGS);
        const h = (() => {
            const temp = Number.parseInt(this.treeViewSettings.height.replace('%', ''), 10);
            if (Number.isNaN(temp)) {
                return Number.parseInt(DEFAULT_OBJECT_SEARCH_SETTINGS.height.replace('%', ''), 10);
            }
            return temp;
        })();
        this.treeViewSettingsForm.controls.height.setValue(h);
        this.treeViewSettingsForm.controls.width.setValue(this.treeViewSettings.width);
        this.treeViewSettingsForm.controls.width.disable();
        this.treeViewSettingsForm.controls.activeTouchBubble.setValue(this.treeViewSettings.activeTouchBubble);
        this.treeViewSettingsForm.controls.height.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (newHeight: number | null) => {
            const settings = await this.localStorageService.get<TreeViewDisplaySettings>('treeviewSettings', 'SwissWebConfigDB', false, DEFAULT_OBJECT_SEARCH_SETTINGS);
            settings.height = (newHeight || Number.parseInt(DEFAULT_OBJECT_SEARCH_SETTINGS.height.replace('%', ''), 10)) + '%';
            await this.localStorageService.add('treeviewSettings', settings, 'SwissWebConfigDB');
        });
        this.treeViewSettingsForm.controls.activeTouchBubble.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (b: boolean | null) => {
            const settings = await this.localStorageService.get<TreeViewDisplaySettings>('treeviewSettings', 'SwissWebConfigDB', false, DEFAULT_OBJECT_SEARCH_SETTINGS);
            settings.activeTouchBubble = !!b;
            await this.localStorageService.add('treeviewSettings', settings, 'SwissWebConfigDB');
        });

        this.serviceAppSettingsForm.controls.showTime.setValue(await this.localStorageService.get<boolean>('showOrdersFromTime', SWISS_SERVICE_APP_DB_STORE_NAME, false, false));
        this.serviceAppSettingsForm.controls.showTime.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (b: boolean | null) => {
            await this.localStorageService.add('showOrdersFromTime', b, SWISS_SERVICE_APP_DB_STORE_NAME);
        });
    }

    public async changeInPast(event: any): Promise<void> {
        this.syncPeriod.syncInPast = event.target.value;
        await this.localStorageService.add('service-app-mobile-config', this.syncPeriod, 'SwissWebConfigDB');
    }

    public async changeInFuture(event: any): Promise<void> {
        this.syncPeriod.syncInFuture = event.target.value;
        await this.localStorageService.add('service-app-mobile-config', this.syncPeriod, 'SwissWebConfigDB');
    }

    public async checked(event: any): Promise<void> {
        this.syncPeriod.notClosedOrder = event.target.checked;
        await this.localStorageService.add('service-app-mobile-config', this.syncPeriod, 'SwissWebConfigDB');
    }

    public async updateDeviceSettingsFlag(event, flag): Promise<void> {
        const val = event.checked;
        await this.localStorageService.add(flag, val, 'SwissWebConfigDB');
    }

    public loadServiceAppConfig(): void {
        this.spesenarten = this.svcSA.getDBSpesen();
        this.svcTimeSheet.getKostenstellen().subscribe({
            next: (res) => {
                if (res) {
                    this.kostenstellen = res;

                    const defaultCostsCenter = this.currentUser()?.sA_DefaultCostCenter;
                    if (defaultCostsCenter) {
                        this.sa_DefaultUserCostCenter = this.kostenstellen.find((c) => c.costCenterID === defaultCostsCenter);
                    }

                    this.svcSA.getCurrentSAConfig().subscribe({
                        next: (res2: ServiceAppModels.SA_Config | undefined) => {
                            if (res2) {
                                // Hier wird die Serverseitige Konfiguration neu geladen. Diese hat Einfluss auf den Up- & Download.
                                this.sa_Config = res2;
                                this.sa_DefaultCostCenter = this.kostenstellen.filter((c) => c.costCenterID == this.sa_Config?.standardKostenstelle)[0];
                                this.sa_DefaultMatExpense = this.spesenarten.filter((e) => e.expenseID == this.sa_Config?.spesenartMaterialeinkauf)[0];
                                this.sa_DefaultMatCostCenter = this.kostenstellen.filter((c) => c.costCenterID == this.sa_Config?.kostenstelleMaterialeinkauf)[0];

                                this.svcSA.getDefaultObjekt().then((x) => this.sa_DefaultObject = x);
                            }
                        }, error: (error: any) => {
                            console.error(error);
                            this.svcMessageBox.showError('Die Konfiguration der Service-App konnte nicht ermittelt werden!!', '!! FEHLER !!');
                        },
                    });
                }
            }, error: (error) => {
                console.error(error);
                this.svcMessageBox.showError('Die Kostenstellen konnten nicht ermittelt werden!!', '!! FEHLER !!');
            },
        });
    }

    public dropdownStartPageChange(event: MatSelectChange): void {
        this.swissAppUserConfig!.startPage = event.value;
        this.svcSwissSettings.setStartPage(event.value);
    }

    public async onGridStartChange(value?: any): Promise<void> {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            const wert = value.target.value;
            if (wert.length === 5) {
                this.timeGridStart = wert;
                this.svcSwissSettings.setTimeGrid(wert, this.timeGridEnd);
            }
            console.log('Grid Start', value.target.value);
        }
    }

    public async onGridEndChange(value?: any): Promise<void> {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            const wert = value.target.value;
            if (wert.length === 5) {
                this.timeGridEnd = wert;
                this.svcSwissSettings.setTimeGrid(this.timeGridStart, wert);
            }
            console.log('Grid End', value.target.value);
        }
    }

    public async onWorkDayStartChange(value?: any): Promise<void> {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            const wert = value.target.value;
            if (wert.length === 5) {
                this.timeWorkDayStart = wert;
                this.svcSwissSettings.setTimeGridWorkDay(wert, this.timeWorkDayEnd);
            }
            console.log('Grid WorkDay Start', value.target.value);
        }
    }

    public async onWorkDayEndChange(value?: any): Promise<void> {
        if (value && value.target && value.target.value) {
            // Wert wird nur gespeichert, wenn dieser 5-stellig ist
            const wert = value.target.value;
            if (wert.length === 5) {
                this.timeWorkDayEnd = wert;
                this.svcSwissSettings.setTimeGridWorkDay(this.timeWorkDayStart, wert);
            }
            console.log('Grid WorkDay End', value.target.value);
        }
    }

    async webEditionImport(): Promise<void> {
        this.svcMainData.getMitarbeiter().subscribe({
            next: (res) => {
                if (this.webUserConfig.debugMode) {
                    console.log('Mitarbeiter', res);
                }
                this.localStorageService.add('mitarbeiter', res, this.storageWebMain);
            }, error: (error) => console.error('Mitarbeiter konnten nicht heruntergeladen werden. ', error),
        });

        // Gruppennamen
        this.svcMainData.getMitarbeiterGruppen().subscribe({
            next: (res) => {
                if (this.webUserConfig.debugMode) {
                    console.log('Mitarbeitergruppen', res);
                }
                this.localStorageService.add('mitarbeitergruppen', res, this.storageWebMain);
            }, error: (error) => console.error('Gruppennamen konnten nicht heruntergeladen werden. ', error),
        });

        // Gruppenzuordnungen
        this.svcMainData.getMitarbeiterGruppenZuord().subscribe({
            next: (res) => {
                if (this.webUserConfig.debugMode) {
                    console.log('MitarbeiterGruppenZuord', res);
                }
                this.localStorageService.add('mitarbeitergruppenzuord', res, this.storageWebMain);
            }, error: (error) => console.error('Gruppenzuordnungen konnten nicht heruntergeladen werden. ', error),
        });

        await this.userAuthService.getSwissAppMandanten();

        this.svcMainData.getUserTermine().subscribe({
            next: (res) => {
                if (this.webUserConfig.debugMode) {
                    console.log('Termine', res);
                }
                this.localStorageService.add('termine', res, this.storageWebMain);
            }, error: (error) => console.error('Termine/Pendenzen konnten nicht heruntergeladen werden. ', error),
        });

        this.svcObjekte.getAllFormFields().subscribe({
            next: (res: any) => {
                if (this.webUserConfig.debugMode) {
                    console.log('Feldkonfigurationen', res);
                }
                this.localStorageService.add('feldKonfigurationen', res, this.storageWebMain);
            }, error: (error: any) => console.error('Feldkonfigurationen konnten nicht heruntergeladen werden. ', error),
        });

        this.svcObjekte.getAddressTypen().subscribe({
            next: (res: any) => {
                if (this.webUserConfig.debugMode) {
                    console.log('AdressTypen', res);
                }
                this.localStorageService.add('adressTypen', res, this.storageWebMain);
            }, error: (error: any) => console.error('Adress-Typen konnten nicht heruntergeladen werden. ', error),
        });

        await this.svcSwissSettings.loadReports();
    }

    async serviceAppImport(): Promise<void> {
        try {
            this.helperService.lockApp();
            this.helperService.pausePeriodicalChecks();
            this.hideLoading.next(false);
            this.importProgress.next(0);
            this.currentUser.set(await this.userAuthService.getUserData());
            await new Promise((resolve, reject) => {
                this.svcSA.getStammdaten().subscribe({
                    next: async (res1: any) => {
                        await this.localStorageService.add('stammdaten', res1, this.storageServiceApp);
                        resolve(true);
                    },
                    error: () => {
                        reject(new Error('Stammdaten konnten nicht geladen werden'));
                    }
                });
            });
            this.importProgress.next(5);
            await new Promise((resolve, reject) => {
                this.svcSA.getCurrentSAConfig().subscribe({
                    next: async (conf) => {
                        this.sa_Config = conf;
                        await this.localStorageService.add('sa_config', conf, this.storageServiceApp);
                        resolve(true);
                    },
                    error: () => {
                        reject(new Error('ServiceApp Konfiguration konnte nicht geladen werden'));
                    }
                });
            });
            this.importProgress.next(7);

            const dc = await this.svcSA.getDefaultObjekt();
            this.sa_DefaultObject = dc;
            await this.localStorageService.add('standardObjekt', dc, this.storageServiceApp);

            this.importProgress.next(10);

            await new Promise((resolve, reject) => {
                this.svcSA.getProdukte().subscribe({
                    next: async (res: any) => {
                        await this.localStorageService.add('produkte', res, this.storageServiceApp);
                        resolve(true);
                    },
                    error: () => {
                        reject(new Error('Produkte konnten nicht geladen werden'));
                    }
                });
            });
            this.importProgress.next(13);

            await this.svcSA.downloadObjekte();
            this.importProgress.next(15);
            const documentsSyncTask = await this.svcSA.downloadDocuments();
            const downloadInfo = documentsSyncTask.getDownloadInformation();
            this.totalDocuments.next(downloadInfo.totalDocumentToDownload);
            downloadInfo.totalDownloadedDocuments$.subscribe((totalDownloaded) => {
                this.importProgress.next(15 + (totalDownloaded / downloadInfo.totalDocuments * 80));
                this.downloadedDocuments.next(totalDownloaded);
            });

            const res = await documentsSyncTask.downloadDocuments();
            if (res) {
                await this.svcSA.loadDataForServiceApp();
            } else {
                console.log('Es konnten keine Objekte geladen werden für den Import von Dokumenten. ');
            }

            const serviceRapport = this.swissAppReports.find(x => x.iD_SwissAppReportType === 1);
            if (serviceRapport?.pdfReportHeaderLogo) {
                await new Promise((resolve, reject) => {
                    this.svcSA.getRapportHeaderLogo(serviceRapport.pdfReportHeaderLogo).subscribe({
                        next: async (logo) => {
                            await this.localStorageService.add('rapport_header_logo', logo, this.storageServiceApp);
                            resolve(true);
                        },
                        error: (error: any) => {
                            console.error('Report Logo konnte nicht geladen werden');
                            console.error(error);
                            resolve(false);
                        }
                    });
                });
            }

            // Checkliste(n) herunterladen
            this.mandanten = await this.userAuthService.getSwissAppMandanten();
            for (const mandant of this.mandanten) {
                if (mandant.checkListePath) {
                    await this.svcSA.getChecklisteTemplate(mandant);
                }
            }
            this.importProgress.next(100);
            const d = new Date();
            await this.localStorageService.add('last_SA_sync', d, 'SwissWebConfigDB', false, true);
            await this.localStorageService.add('last_SA_full_sync', d, 'SwissWebConfigDB', false, true);
        } finally {
            this.helperService.unlockApp();
            this.helperService.restartPeriodicalChecks();
            await this.svcMessageBox.showSuccessOK('MAIN_APP_DIALOG.OK_DIALOG.IMPORT_SUCCESS.text', 'MAIN_APP_DIALOG.OK_DIALOG.IMPORT_SUCCESS.title');
        }
    }

    onChange(event: any): void {
        const files = event.target?.files;

        if (files[0]) {
            if (this.backupService.acceptableFile(files[0]) && files.length === 1) {
                if (this.vinbkInput?.nativeElement) {
                    this.vinbkInput.nativeElement.files = files;
                    this.backUpFileName = files[0].name;
                    this.allowBKImport();
                }
            } else {
                this.disallowBKImport();
            }
        }
    }

    public startDBControl(): void {
        // CTRL-Taste muss gedrückt sein
        if (this.key === 'Control') {
            this.router.navigate(['dbcontrol']);
        }
    }

    onDrop(event: DragEvent): void {
        const file = event.dataTransfer?.items[0];

        if (file) {
            if (!this.backupService.acceptableFile(file)) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                if (this.vinbkInput?.nativeElement) {
                    this.vinbkInput.nativeElement.value = '';
                }
                return;
            }
        }
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        const file = event.dataTransfer?.items[0];
        if (file) {
            if (this.backupService.acceptableFile(file)) {
                this.allowBKImport();
                return;
            }
            this.disallowBKImport();
        }
    }

    downloadBackup(): void {
        this.backupService.downloadBackUp();
    }

    downloadServerBackup(): void {
        this.backupService.downloadServerBackup();
    }

    restoreServerBackup(): void {
        this.backupService.restoreServerBackup();
    }

    private async loadServerBackupInfo(): Promise<void> {
        this.serverBackupInfo.set(await this.backupService.getServerBackupInfo());
    }

    allowBKImport(): void {
        this.vinbkupUpload?.nativeElement.classList.add('acceptedFile');
        this.vinbkupUpload?.nativeElement.classList.remove('badFile');
        this.vinbkApply.nativeElement.classList.add('acceptedFile');
        this.vinbkApply.nativeElement.classList.remove('badFile');
    }

    async disallowBKImport(): Promise<void> {
        this.vinbkInput.nativeElement.value = '';
        this.vinbkupUpload?.nativeElement.classList.add('badFile');
        this.vinbkupUpload?.nativeElement.classList.remove('acceptedFile');
        this.vinbkApply?.nativeElement.classList.add('badFile');
        this.vinbkApply?.nativeElement.classList.remove('acceptedFile');
    }

    async loadBackup(): Promise<void> {
        await this.backupService.loadBackup(this.vinbkInput);
    }

    public speedMenuClicked(args: SpeedDialItemEventArgs): void {
        switch (args.item.id) {
            case (args.item.id = 'settings'):
                this.helperService.setPageRefreshURL('appeinstellungen');
                this.router.navigateByUrl('appeinstellungen');
                break;
            case (args.item.id = 'serviceapp'):
                this.helperService.setPageRefreshURL('/serviceapp/saagenda');
                // Zu Homelayout navigieren
                this.router.navigate(['serviceapp/saagenda']);
                break;
            case (args.item.id = 'timeApp'):
                this.helperService.setPageRefreshURL('/timeapp');
                // Zu Homelayout navigieren
                this.router.navigate(['timeapp']);
                break;
            case (args.item.id = 'logout'):
                this.userAuthService.logoutUser('/login');
                break;
            default:
                return;
        }
    }

    public setShowStatusColorInTree(enabled: boolean): void {
        this.svcSwissSettings.setShowStatusColorInTreeview(enabled).subscribe({
            next: async () => {
                await this.svcSwissSettings.reloadUserConfig();
            },
            error: (error) => {
                this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ShowObjectStatusColorInTreeError.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ShowObjectStatusColorInTreeError.title');
            }
        });
    }

    protected async uploadLocalDocuments(): Promise<void> {
        this.helperService.lockApp(false, true);
        const result = await this.documentManagementService.syncDocuments();
        if (result.errorCount === 0) {
            this.svcMessageBox.showSuccessByLanguageKey('MAIN_APP_SETTINGS.SYNC_DOCUMENTS.SYNC_RESULT.ALL_SUCCESS.text', 'MAIN_APP_SETTINGS.SYNC_DOCUMENTS.SYNC_RESULT.ALL_SUCCESS.title');
        } else if (result.successCount > 0) {
            this.svcMessageBox.showSuccessByLanguageKey('MAIN_APP_SETTINGS.SYNC_DOCUMENTS.SYNC_RESULT.WITH_ERRORS.text', 'MAIN_APP_SETTINGS.SYNC_DOCUMENTS.SYNC_RESULT.WITH_ERRORS.title', ['' + result.successCount, '' + result.errorCount]);
        } else {
            this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_SETTINGS.SYNC_DOCUMENTS.SYNC_RESULT.ALL_ERRORS.text', 'MAIN_APP_SETTINGS.SYNC_DOCUMENTS.SYNC_RESULT.ALL_ERRORS.title');
        }
        const keys = await this.documentManagementService.getAllDocumentIDs();
        this.nrOfDocs.next(keys.length);
        this.helperService.unlockApp();
    }

    protected async setTreeSorting(checked: boolean): Promise<void> {
        this.webUserConfig.sortTreeView = checked;
        await this.svcSwissSettings.updateWebUserConfig(this.webUserConfig);
    }

    private async createNavBubble(): Promise<void> {
        this.navBarShown = setInterval(() => {
            this.showNav = 'hidden' === (document.getElementsByTagName('mat-sidenav')[0] as HTMLElement).style.visibility;
        }, 200);
        if (await this.userAuthService.hasLicences(BenutzerModels.UserLicenses.CMobileTime)) {
            this.menuItems.push({text: 'Zeiterfassung', id: 'timeApp'});
        }
        if (await this.userAuthService.hasLicences(BenutzerModels.UserLicenses.CServiceApp)) {
            this.menuItems.push({text: 'Service App', id: 'serviceapp'});
        }
        this.menuItems.push({text: 'Abmelden', id: 'logout'});
    }
}
